{
	"_comment": "This file is updated by the build process. Do not edit it manually.",
	"version": "1.70.0",
	"hash": "c56f92f600244b8629583a324bea74cc91722a9e"
}
